<template>
<div>
    <vx-card>
        <vs-tabs v-model="activeTab">
            <vs-tab label="Facturado por Asesor">
                <vx-card title="Seleccione el período para desplegar">
                    <small>Buscar periodo:</small>
                    <v-select :options="arrayPeriodos" :reduce="periodo => periodo" @input="f_selectPeriodo" label="periodoescolar" class="w-full" v-model="periodoSelect" />
                </vx-card>
                <!-- Components -->
                <div v-if="mostrar" class="mt-4">
                    <vx-card>
                        <ReporteFacturadoXAsesores :periodo_id="periodo_id" :nombrePeriodo="nombrePeriodo" :ifExterno="Number(1)" v-if="periodoSelect" />
                    </vx-card>
                </div>
            </vs-tab>
            <vs-tab label="Facturado por Año">
                <vs-tabs v-model="activeSubTab1">
                    <vs-tab label="Prolipa">
                        <ReporteFacturadoFecha />
                    </vs-tab>
                    <vs-tab label="Iluminar">
                        <ReporteFacturadoFechaI />
                    </vs-tab>
                </vs-tabs>
            </vs-tab>
            <vs-tab label="Despachado x Bodega por Año">
                <vs-tabs v-model="activeSubTab2">
                    <vs-tab label="Prolipa">
                        <ReporteVendidoFecha />
                    </vs-tab>
                    <vs-tab label="Iluminar">
                        <ReporteVendidoFechaI />
                    </vs-tab>
                </vs-tabs>
            </vs-tab>
            <vs-tab label="Cobrado por Año">
                <vs-tabs v-model="activeSubTab3">
                    <vs-tab label="Prolipa">
                        <ReporteCobradoFecha />
                    </vs-tab>
                    <vs-tab label="Iluminar">
                        <ReporteCobradoFechaI />
                    </vs-tab>
                </vs-tabs>
            </vs-tab>
            <vs-tab label="Reportes Ventas-Abonos-Devoluciones">
                <vs-tabs v-model="activeSubTab4" class="mt-4">
                    <vs-tab label="Prolipa">
                        <vx-card title="Seleccione el período ">
                            <small>Buscar periodo:</small>
                            <v-select :options="arrayPeriodos" :reduce="periodo => periodo" label="periodoescolar" class="w-full" v-model="periodoSelect" />
                        </vx-card>
                        <ReporteVentas :periodoSelect="periodoSelect" v-if="periodoSelect" />
                    </vs-tab>
                    <vs-tab label="Iluminar">
                        <vx-card title="Seleccione el período ">
                            <small>Buscar periodo:</small>
                            <v-select :options="arrayPeriodosIluminar" :reduce="periodo => periodo" label="periodoescolar" class="w-full" v-model="periodoIluminarSelect" />
                        </vx-card>
                        <ReporteVentasI :periodoSelect="periodoIluminarSelect" v-if="periodoIluminarSelect" />
                    </vs-tab>
                </vs-tabs>
            </vs-tab>
            <vs-tab label="Desfase en Saldos Facturados">
                <vx-card title="Seleccione el período ">
                    <small>Buscar periodo:</small>
                    <v-select :options="arrayPeriodos" :reduce="periodo => periodo" label="periodoescolar" class="w-full" v-model="periodoSelect" />
                    <vs-tabs v-model="activeSubTab5" class="mt-4">
                        <vs-tab label="Prolipa">
                            <desfasFacturacion :periodoSelect="periodoSelect" :empresa="1" />
                        </vs-tab>
                        <vs-tab label="Calmed">
                            <desfasFacturacion :periodoSelect="periodoSelect" :empresa="3" />
                        </vs-tab>
                    </vs-tabs>
                </vx-card>
            </vs-tab>
            <vs-tab label="Cuentas X Cobrar">
                <vs-tabs v-model="activeSubTab6">
                    <vs-tab label="Prolipa">
                        <ReporteCuentasXCobrar />
                    </vs-tab>
                </vs-tabs>
            </vs-tab>
            <vs-tab label="Asociar Notas de Credito">
                <vs-tabs v-model="activeSubTab7">
                    <vs-tab label="Prolipa">
                        <AsociarnotasCredito :empresa="1" />
                    </vs-tab>
                    <vs-tab label="Calmed">
                        <AsociarnotasCredito :empresa="3" />
                    </vs-tab>
                </vs-tabs>
            </vs-tab>
        </vs-tabs>
    </vx-card>
</div>
</template>

<script>
import PeriodoRepository from '@/repositories/PeriodoRepository';
const ReporteFacturadoXAsesores = () => import('../../pedidos2/pedidos/reportes/ReporteFacturadoXAsesores.vue');
const ReporteFacturadoFecha = () => import('@/views/pedidos2/pedidos/reportes/ReporteFacturadoXFecha.vue');
const ReporteFacturadoFechaI = () => import('@/views/pedidos2/pedidos/reportes/ReporteFacturadoXFechaI.vue');
const ReporteVendidoFecha = () => import('@/views/pedidos2/pedidos/reportes/ReporteVendidoXFecha.vue');
const ReporteVendidoFechaI = () => import('@/views/pedidos2/pedidos/reportes/ReporteVendidoXFechaI.vue');
const ReporteCobradoFecha = () => import('@/views/pedidos2/pedidos/reportes/ReporteCobradoXFecha.vue');
const ReporteCobradoFechaI = () => import('@/views/pedidos2/pedidos/reportes/ReporteCobradoXFechaI.vue');
const ReporteVentas = () => import('@/views/pedidos2/pedidos/reportes/components/reporteCobranza.vue');
const desfasFacturacion = () => import('@/views/pedidos2/pedidos/proforma/desfasFacturacion.vue');
const ReporteVentasI = () => import('@/views/pedidos2/pedidos/reportes/components/reporteCobranzaI.vue');
const ReporteCuentasXCobrar = () => import('@/views/pedidos2/pedidos/reportes/ReporteCuentasXCobrar.vue');
const AsociarnotasCredito = () => import('@/views/pedidos2/pedidos/reportes/AsociarnotasCredito.vue');


import vSelect from 'vue-select';
import Generalmix from '../../../mixins/Generalmix';

export default {
    mixins: [Generalmix],
    components: {
        vSelect,
        ReporteFacturadoXAsesores,
        ReporteFacturadoFecha,
        ReporteVendidoFecha,
        ReporteVendidoFechaI,
        ReporteFacturadoFechaI,
        ReporteCobradoFecha,
        ReporteCobradoFechaI,
        ReporteVentas,
        ReporteVentasI,
        desfasFacturacion,
        ReporteCuentasXCobrar,
        AsociarnotasCredito,
    },
    data() {
        let activeTab = 0;
        let activeSubTab1 = 0;
        let activeSubTab2 = 0;
        let activeSubTab3 = 0;
        let activeSubTab4 = 0;
        let activeSubTab5 = 0;
        let activeSubTab6 = 0;
        let activeSubTab7 = 0;

        try {
            const savedState = JSON.parse(localStorage.getItem('tabsState'));
            if (savedState) {
                activeTab = savedState.activeTab || 0;
                activeSubTab1 = savedState.activeSubTab1 || 0;
                activeSubTab2 = savedState.activeSubTab2 || 0;
                activeSubTab3 = savedState.activeSubTab3 || 0;
                activeSubTab4 = savedState.activeSubTab4 || 0;
                activeSubTab5 = savedState.activeSubTab5 || 0;
                activeSubTab6 = savedState.activeSubTab6 || 0;
                activeSubTab7 = savedState.activeSubTab7 || 0;
            }
        } catch (error) {
            console.error('Error al leer el estado de localStorage:', error);
        }

        return {
            activeTab,
            activeSubTab1,
            activeSubTab2,
            activeSubTab3,
            activeSubTab4,
            activeSubTab5,
            activeSubTab6,
            activeSubTab7,
            arrayPeriodos: [],
            arrayPeriodosIluminar: [],
            periodo_id: 0,
            nombrePeriodo: '',
            periodoSelect: null,
            periodoIluminarSelect: null,
            mostrar: false,
            radios1: 'Prolipa',
            //totales 
            totalVentasBodega: 0,
            totalVentasFacturacion: 0,
            totalVentasPerseo: 0,
            periodoSelectTotales: null,
            periodoIluminarSelectTotales: null,

            datosVentas: [],
            totalGeneral: 0,

        };
    },
    mounted() {
        this.obtenerPeriodos();
        this.obtenerPeriodosIluminar();
    },
    methods: {
        obtenerPeriodosIluminar() {
            PeriodoRepository.getPeriodosIluminar()
                .then(p => {
                    this.arrayPeriodosIluminar = p.data.filter(p => p.reporte_contabilidad == 1);
                })
                .catch(error => {
                    this.m_message("Error al cargar los períodos", "error");
                    console.error(error);
                });
        },
        obtenerPeriodos() {
            PeriodoRepository.getPeriodos()
                .then(p => {
                    this.arrayPeriodos = p.data.filter(p => p.reporte_contabilidad == 1);
                })
                .catch(error => {
                    this.m_message("Error al cargar los períodos", "error");
                    console.error(error);
                });
        },
        f_selectPeriodo() {
            this.mostrar = false;
            this.$vs.loading();

            setTimeout(() => {
                if (!this.periodoSelect) {
                    this.m_message("Seleccione un periodo por favor", "warning");
                    this.$vs.loading.close();
                    return;
                }

                this.periodo_id = this.periodoSelect.idperiodoescolar;
                this.nombrePeriodo = this.periodoSelect.periodoescolar;
                this.mostrar = true;
                this.$vs.loading.close();
            }, 1000);
        },
        saveTabState() {
            const state = {
                activeTab: this.activeTab,
                activeSubTab1: this.activeSubTab1,
                activeSubTab2: this.activeSubTab2,
                activeSubTab3: this.activeSubTab3,
                activeSubTab4: this.activeSubTab4,
            };
            localStorage.setItem('tabsState', JSON.stringify(state));
        },
    },
    watch: {
        activeTab(newTab) {
            this.saveTabState();
        },
        activeSubTab1(newSubTab1) {
            this.saveTabState();
        },
        activeSubTab2(newSubTab2) {
            this.saveTabState();
        },
        activeSubTab3(newSubTab3) {
            this.saveTabState();
        },
        activeSubTab4(newSubTab4) {
            this.saveTabState();
        },
    },
};
</script>
